import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const History = () => {
  return (
    <React.Fragment>
      <SEO title="History | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="History"
        content="The Conference"
        contentTwo="History"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
            <div className="history">
            <ul className="home-p">
                                <li><a href="http://www.iasei.org/dmbd2024/">The Ninth International Conference on Data
                                Mining and Big Data (DMBD 2024)</a>, December 13-16, 2024, Ho Chi Minh City, Vietnam.</li>
                                <li><a href="http://www.iasei.org/dmbd2023/">The Eighth International Conference on Data
                                        Mining and Big Data (DMBD 2023)</a>, December 9-12, 2023, Sanya, China.</li>
                                <li><a href="http://www.iasei.org/dmbd2022/">The Seventh International Conference on Data
                                        Mining and Big Data (DMBD 2022)</a>, November 21-24, 2022, Beijing, China.</li>
                                <li><a href="http://www.iasei.org/dmbd2021/">The Sixth International Conference on Data
                                        Mining and Big Data (DMBD 2021)</a>, October 20-22, 2021, Guangzhou, China.</li>
                                <li><a href="http://www.iasei.org/dmbd2020/">The Fifth International Conference on Data
                                        Mining
                                        and Big Data (DMBD 2020)</a>, July 14-20, 2020, Belgrade, Serbia.</li>
                                <li><a href="http://www.iasei.org/dmbd2019/">The Fourth International Conference on Data
                                        Mining
                                        and Big Data (DMBD 2019)</a>, July 26-30, 2019, Chiang Mai, Thailand.</li>
                                <li><a href="http://www.iasei.org/dmbd2018/">The Third International Conference on Data
                                        Mining
                                        and Big Data (DMBD 2018)</a>, June 17-22, 2018, Shanghai, China.</li>
                                <li><a href="http://www.iasei.org/dmbd2017/">The Second International Conference on Data
                                        Mining
                                        and Big Data (DMBD 2017)</a>, July 27-Agugust 01, 2017, JR Hakata City, Fukuoka,
                                    Japan.</li>
                                <li><a href="http://www.iasei.org/dmbd2016/">The First International Conference on Data
                                        Mining
                                        and Big Data (DMBD 2016)</a>, June 25-30, 2016, Padma Resort at Legian, Bali,
                                    Indonesia.</li>
                            </ul>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default History;
